module.exports = __webpack_public_path__ + "img/ai.4f956cff.png";